module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--register main--register-patient"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "title": "Create Your VeriTooth Account",
      "slug": "registerPatient",
      "copy": "Create your account to request your dental records and get feedback on the work. Once your account is set up you can request your records from your dentist and get notified of reviews.",
      "submit": "Create Account"
    }
  }, [_c('div', {
    attrs: {
      "slot": "top-link"
    },
    slot: "top-link"
  }, [_c('p', {
    staticClass: "small"
  }, [_vm._v("Already have an account? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('br'), _vm._v("Are you a dentist? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register-dentist'
      }
    }
  }, [_vm._v("Register as a Dentist")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "before-submit"
    },
    slot: "before-submit"
  }, [_c('p', {
    staticClass: "mt0 mb0 small"
  }, [_vm._v("By signing up you agree to the VeriTooth")]), _vm._v(" "), _c('p', {
    staticClass: "mt0 small"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'terms'
      },
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" and "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      },
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cfbe2cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/register/RegisterPatient.vue
// module id = 320
// module chunks = 0